import { render, staticRenderFns } from "./CoachCompletedObservations.vue?vue&type=template&id=2b4dac50&scoped=true"
import script from "./CoachCompletedObservations.vue?vue&type=script&lang=js"
export * from "./CoachCompletedObservations.vue?vue&type=script&lang=js"
import style0 from "./CoachCompletedObservations.vue?vue&type=style&index=0&id=2b4dac50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4dac50",
  null
  
)

export default component.exports